export default __webpack_public_path__ + "images/JN.9a956fc.png";